import { Button, Icon, CircularLoader, Stack } from "@introist/react-foundation/v2";
import { AccountsHeader } from "./AccountsHeader";
import { AccountsList } from "./AccountsList";
import { ConnectedAccount } from "services/rpc/RpcProvider";
import { ListSection } from "components/organisms";
import { MicrosoftCapabilityModal } from "./MicrosoftCapabilityModal";
import { ReactNode, useState } from "react";

interface Props {
  accounts: ConnectedAccount[];
  description: string;
  isLoading?: boolean;
  bottom?: ReactNode;
}

export const MicrosoftAccountsRoot = ({
  accounts,
  description,
  isLoading = false,
  bottom
}: Props) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <Stack vertical gap="xxLarge">
      <AccountsHeader description={description} />

      {isLoading ? (
        <Stack justifyContent="center">
          <CircularLoader />
        </Stack>
      ) : (
        <ListSection
          title={
            <Stack>
              <span>Microsoft</span>
            </Stack>
          }
          endActions={
            <Button
              size="small"
              variant="outlined"
              onClick={() => setModalOpen(true)}
              startAdornment={<Icon name="link" />}
            >
              Copy connection link
            </Button>
          }
        >
          <AccountsList accounts={accounts} />
        </ListSection>
      )}
      {bottom}

      <MicrosoftCapabilityModal open={modalOpen} onClose={() => setModalOpen(false)} />
    </Stack>
  );
};
